module.exports = __webpack_public_path__ + "media/f-.74464d4b.mp3";